import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';

@Component({
  selector: 'app-app-ticketing',
  templateUrl: './app-ticketing.component.html',
  styleUrls: ['./app-ticketing.component.scss']
})
export class AppTicketingComponent implements OnInit {

  constructor(private modalService: NgbModal, private router: Router, 
    private config: ApiConfiguration, private http : ApiService, 
    private toast: ToastClientService,) { }

  appData = [];

  name = "";
  roleType = "0"
  ngOnInit() {
    this.getData();
  }

  getData(){
    this.http.get(this.config.baseUrl2 + this.config.appTicket)
    .subscribe((data:any)=>{
      this.appData = data.data;
      this.toast.Success("Success")
    })
  }
  showRegionModal(targetModal) {
    this.modalService.open(targetModal, {
      centered: true,
      backdrop: "static",
    });
  }

  addTicket(targetModal){
    this.showRegionModal(targetModal);
  }

  edit(id){
    this.router.navigate(["/hubAdmin/edit-ticketing", {id:id}])
  }

  createTicketSubject(){
    if(this.name == "" || this.roleType == ""){

      this.toast.Error("Fields are required")
    }else{
      let payload = {
        ticket_type_name:this.name,
        is_visible_roles:this.roleType,
        program_id:1
      }
      this.http.post(this.config.baseUrl2 + this.config.createAppTicket, payload)
      .subscribe((data:any)=>{
        this.toast.Success("Success");
        this.modalService.dismissAll();
        this.getData()
      }, (err)=>{
        console.log(err.message)
      })
    }
  }
  omit_special_char(event)
  {   
     var k;  
     k = event.charCode; 
     return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57)); 
  }
}
